export const ServerConfig = {
    useLocalPort: false,
    localPortDomain: 'http://localhost:5001'
}

export const Headers = {
    "Content-Type": "application/json"
}
